import { DatePicker as AntdDatePicker, type DatePickerProps } from 'antd'
import styled from 'styled-components'

// @ts-ignore
export default (props: DatePickerProps) => <AntdDatePickerStyled {...props} />

const AntdDatePickerStyled = styled(AntdDatePicker)`
  width: 100%;
`
